const routerList = [

	{
		path:"/index/:company?/:activeNav?",
		component:"index/index",
		name:'首页',
	},
	{
		path:"/invoice/:company?",
		component:"index/invoice",
		name:'开票信息',
	},
];

export default  (()=>{
	let router = [];
	for(let v of routerList){
		router.push({
			path: v.path,
			component:()=>import(`@/views/${v.component}`),
			meta:v,
		})
	}

	return router
});
